import { pairingResponderSlide } from "./reducer";

export const { pairingFailed, receivedRequest, resetState } =
  pairingResponderSlide.actions;
